import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";



export default function Terms() {
    return(
        <div>
        <Navbar/>
        <Sidebar />
        <div className='header-container'>
            <h1>Terms and Conditions</h1>
        </div>
        <div className='description-container'>
        <p className='description-paragraph '>Terms and conditions page</p>
        </div>  
        <div className='table-container'></div>
        </div>
    )
}